export const formatCurrency = ({ value, lang = 'ja-JP', currency = 'JPY', negative = 'before', showSymbol = true }) => {
    const formatter = new Intl.NumberFormat(lang, {
        style: showSymbol ? 'currency' : 'decimal',
        currency,
        minimumFractionDigits: 0
    }).format(Math.abs(value));
    if (value < 0) {
        return negative === 'before' ? `-${formatter}` : `${formatter[0]}-${formatter.slice(1)}`;
    }
    return formatter;
};
export function formatCountNumber(count) {
    if (!count) {
        return '0';
    }
    if (count < 1000) {
        return count.toString();
    }
    return count.toLocaleString('ja-JP');
}
